import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { mockData } from '../data/mock';
import { MapPin, Clock, Train, Navigation } from 'lucide-react';

const LocationSection = () => {
  const { t } = useLanguage();

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Info */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-8">
              {t('location.title')}
            </h2>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-red-50 rounded-xl">
                  <MapPin className="w-6 h-6 text-red-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-neutral-900 mb-1">
                    {t('location.address')}
                  </h3>
                  <p className="text-neutral-600">{t('location.city')}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="p-3 bg-red-50 rounded-xl">
                  <Train className="w-6 h-6 text-red-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-neutral-900 mb-1">
                    {t('location.info')}
                  </h3>
                  <p className="text-neutral-500 text-sm mt-1">
                    {t('location.nearStation')}
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="p-3 bg-red-50 rounded-xl">
                  <Clock className="w-6 h-6 text-red-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-neutral-900 mb-1">
                    {t('courseTimes.title')}
                  </h3>
                  <p className="text-neutral-600">
                    {t('courseTimes.day')} • {t('courseTimes.time')}
                  </p>
                  <p className="text-sm text-neutral-500 mt-1">
                    {t('courseTimes.duration')}
                  </p>
                </div>
              </div>

              {/* Navigation Button */}
              <a
                href="https://maps.google.com/?q=Ellerstraße+53,+40227+Düsseldorf"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-xl font-semibold transition-colors"
              >
                <Navigation className="w-5 h-5" />
                <span>{t('location.title')} öffnen</span>
              </a>
            </div>
          </div>

          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-xl h-[400px] relative">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2498.8651789897597!2d6.783387776893945!3d51.21491652712879!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b8ca1a9b0d5c5d%3A0x4d95f6b75a9a6c5!2sEllerstra%C3%9Fe%2053%2C%2040227%20D%C3%BCsseldorf!5e0!3m2!1sde!2sde!4v1699999999999!5m2!1sde!2sde"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Erste-Hilfe Fokus Standort"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
